export const CURSOR_TRAIL_CONFIG = {
  IMAGE_COUNT: 37,
  SLICE_COUNT: 10,
  SIZE: 175,
  MOUSE_THRESHOLD: 150,
  IMAGES_BASE_PATH: "/images/cursor-trail",
  IMAGE_PREFIX: "ct-",
  IMAGE_EXTENSION: ".webp",
};
